import React, { useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
import PasswordFormGroup from './PasswordFormGroup.jsx';
import ButtonLoaderComponent from '../widgets/ButtonLoaderComponent.jsx';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useToast } from '../../hooks/useToast.jsx';

const ExpiredPasswordComponent = ({ userEmail = null, passwordToken = null, setModalShow = null }) => {
    const { changePassword } = useStoreActions(actions => actions.auth);
    const { constants } = useStoreState(actions => actions.params);

    const [isSending, setIsSending] = useState(false);

    const [newPassword, setNewPassword] = useState('');

    const [isNewPassValid, setIsNewPassValid] = useState(false);

    const toast = useToast();

    const passWordGroup = <PasswordFormGroup
        onValid={(validation, validPass) => {
            setIsNewPassValid(validation);
            setNewPassword(validPass)
        }}
    />;

    const onValidatePWD = () => {

        if (isNewPassValid) {
            const data = new FormData();

            data.append('pwd', newPassword);
            !!userEmail && data.append('userEmail', userEmail);
            !!passwordToken && data.append('passwordToken', passwordToken);

            setIsSending(true);
            changePassword(data)
                .then((res) => {
                    if (res) {
                        toast.open({ message: "Le mot de passe a bien été modifié", variant: "success" });
                        setIsSending(false);
                        setModalShow?.(false);
                    }
                })
                .catch((error) => {
                    setIsSending(false);
                    if (error.message == constants?.expiredPasswordRequestMessage) {
                        setModalShow?.(false);
                    }
                })

        }
    };

    return <>

        <Alert variant='info'>
            Votre mot de passe est expiré, merci d'en indiquer un nouveau (différent de l'actuel)
        </Alert>
        <Form noValidate className="mb-3">
            {passWordGroup}
        </Form>
        <ButtonLoaderComponent
            variant='success'
            disabled={!isNewPassValid}
            isSending={isSending}
            msg='Changer le mot de passe'
            onClick={() => { onValidatePWD() }}
        />
    </>;
}

export default ExpiredPasswordComponent;